import type { TaskTrackerFilterFieldType } from '../store/taskTracker.types'

export const DEFAULT_TASK_TRACKER_FILTER_COLOR = '#9747FF'

export const DEFAULT_TASK_TRACKER_FILTER_SELECT_OPTION_COLOR = '#4169E1'

export const TASK_TRACKER_FILTER_TITLE_MAX_LENGTH = 255

export const TASK_TRACKER_FILTER_FIELD_TYPE_OPTIONS: Array<{
  label: string
  value: TaskTrackerFilterFieldType
}> = [
  { label: 'Текст', value: 'text' },
  { label: 'Дата', value: 'date' },
  { label: 'Число', value: 'number' },
  { label: 'Список', value: 'select' },
]

export const TASK_TRACKER_FILTER_FIELD_TYPES =
  TASK_TRACKER_FILTER_FIELD_TYPE_OPTIONS.map((item) => item.value)

export const TASK_TRACKER_STICKER_FILTER_TEXT_DEBOUNCE_MS = 700

export const TASK_TRACKER_BOARD_STICKER_CREATE_CONTEXT_HINT =
  'Стикер будет добавлен в глобальный каталог стикеров таск-трекера и автоматически станет видимым на этой доске.'

export const TASK_TRACKER_BOARD_STICKER_EDIT_CONTEXT_HINT =
  'Изменения сохраняются в глобальном каталоге стикеров таск-трекера и применяются ко всем доскам, где используется этот стикер. Настройки видимости и обязательности только для этой доски здесь не меняются.'

export const TASK_TRACKER_BOARD_STICKER_FORM_MODAL_Z_INDEX = 110

export const TASK_TRACKER_CATALOG_STICKER_CREATE_CONTEXT_HINT =
  'После создания нового стикера включите его в настройках нужных досок — в разделе «Стикеры», — там, где он должен использоваться.'

export const TASK_TRACKER_CATALOG_STICKERS_HINT =
  'После создания стикера включите его видимость в настройках нужных досок — в разделе «Стикеры», — там, где он должен применяться.'
